export default __webpack_public_path__ + "static/media/product2.ee457c81.webp";